import config from "@/config/config.app.json";
import Vue from "vue";
import rhRequest from "requestplugin";
import router from "@/router";
import EventBus from "@/plugins/lib/EventBus";

export default {
    createRHRequest() {
        Vue.use(rhRequest, {platform: window?.cordova?.platformId.toLowerCase(), config: configuration, interceptorCallback, unauthorizedCallback})
    }
}

function unauthorizedCallback() {
    console.error('Session invalid - log-out user')
    Vue.prototype.$rhAuth.logout(() => {
        router.push({
            name: 'login',
            params: {wasUnauthorized: 'true'}
        }).then(() => {
        })
    })
}

function interceptorCallback(response) {
    EventBus.$emit('rhRequest.intercept', response)
}

let configuration = {
    portalApi: config.portalApi,
    "App-Version": config.appVersion,
    userKey: 'user',
    tokenKey: 'token',
    siteKey: "activeSite",
    roleKey: "role",
    requestTimeoutSlow: config.requestTimeoutSlow
}